
import './index.css';

import React from 'react';

import RecordSection from '../RecordSection';
function Metric({ domain }) {
  return (
    <RecordSection
      title="Stat Tracker"
      className="record-stats"
    >
      {domain.metrics?.length === 0 ? (
        <p>No stat tracker entries yet.</p>
      ) : (
        <table className="data-table">
          <thead>
            <tr>
              <th>Metric</th>
              <th>Value</th>
              <th>Target</th>
              <th>Recorded</th>
            </tr>
          </thead>
          <tbody>
            {domain.metrics?.map((metric) => (
              <tr key={metric.data.id}>
                <td>{metric.data.metricLabel}</td>
                <td>{metric.data.value}{metric.data.unit ? ` ${metric.data.unit}` : ''}</td>
                <td>{metric.data.targetValue ?? '-'}</td>
                <td>{metric.data.recordedOn}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </RecordSection>
  );
}

export default Metric;